 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		8: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		8: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"90c4949b099e104b6749da3aa4d4bc387d3dcd1e","2":"3c9c698cbfbd61792166dd0a7f68f1c8149a013d","3":"6c9af54606504f1fba2cc7ab773b6ca0a3ef9130","4":"bd6f28c807f9d7924262c094ce141a3cd820f19b","5":"155253629e8b592c685a3ebf0d13587fd5fb56cd","6":"b48e11d6f1c76735f7f26557e574f4f23b794358","7":"framework","11":"component---cache-caches-gatsby-plugin-offline-app-shell-js","12":"component---src-pages-404-js","13":"component---src-pages-antraege-js","14":"component---src-pages-freunde-danke-js","15":"component---src-pages-freunde-freund-werden-js","16":"component---src-pages-freunde-js","17":"component---src-pages-freunde-mehr-js","18":"component---src-pages-index-js","19":"component---src-pages-kontakt-danke-js","20":"component---src-pages-kontakt-js","21":"component---src-pages-map-js","22":"component---src-pages-news-js","23":"component---src-pages-spende-abbrechen-js","24":"component---src-pages-spende-danke-js","25":"component---src-pages-spendenkonto-js","26":"component---src-pages-sponsoren-js","27":"component---src-pages-stiftung-anlagerichtlinien-js","28":"component---src-pages-stiftung-grundsaetze-js","29":"component---src-pages-stiftung-js","30":"component---src-pages-stiftung-principles-js","31":"component---src-pages-stiftung-transparenz-js","32":"component---src-pages-ueber-uns-beirat-js","33":"component---src-pages-ueber-uns-geschaeftsstelle-js","34":"component---src-pages-ueber-uns-grusswort-apd-js","35":"component---src-pages-ueber-uns-grusswort-bvdd-js","36":"component---src-pages-ueber-uns-grusswort-ddg-js","37":"component---src-pages-ueber-uns-grusswort-nipd-js","38":"component---src-pages-ueber-uns-grusswort-schirmherr-js","39":"component---src-pages-ueber-uns-grusswort-vorstand-js","40":"component---src-pages-ueber-uns-js","41":"component---src-pages-ueber-uns-komitee-js","42":"component---src-pages-ueber-uns-kuratorium-js","43":"component---src-pages-ueber-uns-schirmherr-js","44":"component---src-pages-ueber-uns-vorstand-js","45":"component---src-pages-unterstuetzen-js","46":"component---src-pages-video-js","47":"component---src-pages-vorschau-js","48":"component---src-pages-was-wir-tun-besonderhaut-js","49":"component---src-pages-was-wir-tun-foerderprogramm-js","50":"component---src-pages-was-wir-tun-js","51":"component---src-templates-text-page-templ-js"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"6dcb5a0c7d90dbb6eea6","2":"32898481c21417885fea","3":"ff26fea583d324365b7a","4":"02cd13f90abb4917b6c8","5":"2381e1012da35aa0a2a8","6":"89648db5e261f97aa303","7":"53257ef95d3a7535a9dd","11":"162eda8abf0539b5b76e","12":"629e56686d8b87261910","13":"bfd1cf97e9422b6fd1b9","14":"9b75e7d2bf38ad60e29b","15":"48cc1c938a5aff725ea1","16":"e541ddb3831d7ce3d383","17":"8f0e3e25aac08ff9e779","18":"b58482cc267d49df4c44","19":"5f030d6e220dc58ac23d","20":"6aea77bb73fd07240f6a","21":"6a4d98ccf347635c9a16","22":"521203da4c80f3398592","23":"9211448caf19f7dfa881","24":"d9d2121b0de0feabe15e","25":"dbb157f5b6d46cd7eb35","26":"f37d5b8fd8a689615e9b","27":"f621c429aca0cea43271","28":"d974acfd2762ddb8cc40","29":"07c610c65b2016934699","30":"f17b2984f2baf0f2af7d","31":"502b712b500fc4daaeeb","32":"a8b91dae09f1b02496d2","33":"80efd5af15eac01793ab","34":"d60a6ab7b7c65159de90","35":"072042bb480050dd3264","36":"79881cfe48aa20c37d7c","37":"fece507974071b98f6d3","38":"8671eb1c14da96fecb37","39":"0a42423b7bc03970bd8b","40":"248b13616ea8c2fab586","41":"50a4cd313895033250d4","42":"fe99fb3878c0f59e5e83","43":"34f6b16092f232073e4b","44":"3ba0e7e6f8c24a588d7a","45":"0539344cdf020c916841","46":"7cdabcdebd08123514e7","47":"549e8eed3efba1519f41","48":"7a769e2e527ab36af890","49":"e93025798dba13e58608","50":"e2d6f805f8a448bc4b04","51":"2e4eff4bb2893bc265c0"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"90c4949b099e104b6749da3aa4d4bc387d3dcd1e","2":"3c9c698cbfbd61792166dd0a7f68f1c8149a013d","3":"6c9af54606504f1fba2cc7ab773b6ca0a3ef9130","4":"bd6f28c807f9d7924262c094ce141a3cd820f19b","5":"155253629e8b592c685a3ebf0d13587fd5fb56cd","6":"b48e11d6f1c76735f7f26557e574f4f23b794358","7":"framework","11":"component---cache-caches-gatsby-plugin-offline-app-shell-js","12":"component---src-pages-404-js","13":"component---src-pages-antraege-js","14":"component---src-pages-freunde-danke-js","15":"component---src-pages-freunde-freund-werden-js","16":"component---src-pages-freunde-js","17":"component---src-pages-freunde-mehr-js","18":"component---src-pages-index-js","19":"component---src-pages-kontakt-danke-js","20":"component---src-pages-kontakt-js","21":"component---src-pages-map-js","22":"component---src-pages-news-js","23":"component---src-pages-spende-abbrechen-js","24":"component---src-pages-spende-danke-js","25":"component---src-pages-spendenkonto-js","26":"component---src-pages-sponsoren-js","27":"component---src-pages-stiftung-anlagerichtlinien-js","28":"component---src-pages-stiftung-grundsaetze-js","29":"component---src-pages-stiftung-js","30":"component---src-pages-stiftung-principles-js","31":"component---src-pages-stiftung-transparenz-js","32":"component---src-pages-ueber-uns-beirat-js","33":"component---src-pages-ueber-uns-geschaeftsstelle-js","34":"component---src-pages-ueber-uns-grusswort-apd-js","35":"component---src-pages-ueber-uns-grusswort-bvdd-js","36":"component---src-pages-ueber-uns-grusswort-ddg-js","37":"component---src-pages-ueber-uns-grusswort-nipd-js","38":"component---src-pages-ueber-uns-grusswort-schirmherr-js","39":"component---src-pages-ueber-uns-grusswort-vorstand-js","40":"component---src-pages-ueber-uns-js","41":"component---src-pages-ueber-uns-komitee-js","42":"component---src-pages-ueber-uns-kuratorium-js","43":"component---src-pages-ueber-uns-schirmherr-js","44":"component---src-pages-ueber-uns-vorstand-js","45":"component---src-pages-unterstuetzen-js","46":"component---src-pages-video-js","47":"component---src-pages-vorschau-js","48":"component---src-pages-was-wir-tun-besonderhaut-js","49":"component---src-pages-was-wir-tun-foerderprogramm-js","50":"component---src-pages-was-wir-tun-js","51":"component---src-templates-text-page-templ-js"}[chunkId]||chunkId) + "." + {"0":"f13fadcd50e6331cc64d","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
